export const ModeldownStore = {
  namespaced: true,
  state: {
    isShow: false,
    progressData: {},
  },
  mutations: {
    show(state: any) {
      state.isShow = true;
    },
    hide(state: any) {
      state.isShow = false;
    },
    setProgress(state: any, option: any) {
      const { type, key, progress, status, value } = option;
      switch (type){
        case 'add':
          state.progressData = { ...state.progressData, [key]: value };
          break;
        case 'del':
          delete state.progressData[key];
          break;
        case 'edit_gress':
          state.progressData[key] && progress && (state.progressData[key].progress = progress)
          state.progressData[key] && status && (state.progressData[key].status = status)
          break;
        default:
      }
    }
  },
  getters: {
    
  }
};